import React from "react";

import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Logout from "@mui/icons-material/Logout";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import ChatOutlinedIcon from "@mui/icons-material/ChatOutlined";
import MenuRoundedIcon from "@mui/icons-material/MenuRounded";
import InfoIcon from "@mui/icons-material/Info";
import CircleNotificationsRoundedIcon from "@mui/icons-material/CircleNotificationsRounded";
import { Avatar, Badge, Tooltip } from "@mui/material";
import { removeFromIndexedDB } from "../../storage/profileStorage";
//mui component

import styled from "@emotion/styled";

import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";


import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";

//slice
import { logout } from "../../redux/features/authSlice";
import { clearCart } from "../DonationView/slice";
import { resetDashBoard } from "../DashBoardView/slice";
//redux
import { useDispatch, useSelector } from "react-redux";
//router
import { useNavigate } from "react-router-dom";
//styles
import {
  containerBoxStyles,
  buttonStyles,
  buttonBoxStyles,
  headerButtonStyles,
  badgeColor,
} from "./style";

import {
  ComponentType,
  EntityType,
  RegistrationStatus,
  UserType,
} from "../../common/enum";
import ProfileSelector from "../../sections/auth/ProfileSelector";
import MessageDropdown from "./MessageDropdown";
import MessagePanel from "../MessagePanel";
import MoreVertIcon from '@mui/icons-material/MoreVert';
import {
  query,
  where,
  getCountFromServer,
  collection as firebaseCollection,
  getDocs,
  onSnapshot,
  collectionGroup,
} from "firebase/firestore";
import { db } from "../../firebase";
import NotificationDropdown from "./NotificationDropdown";
import NotificationPanel from "../NotificationPanel";
import MobileDropdown2 from "./Mobile2Dropdown";
import MobilePanel from "../MobilePanel/MobilePanel";
import { ClassNames } from "@emotion/react";
const profileLogged = [
  {
    title: "profileDonor",
    icon: "/static/register/donor.png",
    value: EntityType.donor,
    width: 30,
    height: 27,
  },
  {
    title: "profileDistributor",
    icon: "/static/register/donorReciever.png",
    value: EntityType.distributor,
    width: 27,
    height: 27,
  },
];

const MobilePanelOpenCard = ({
  anchorEl,setMobileMenu, setMobileDrawerState,setNotificationMenu ,setOpenMessagePanel, setOpenNotificationPanel,t 
}) => {
  const handleClick = React.useCallback(() => {
    setOpenMobilePanel(true);
    setobileMenu(null);
  }, []);
  const theme = useTheme();
  const matchesDown = useMediaQuery(theme.breakpoints.down("md"));
  const matchesUp = useMediaQuery(theme.breakpoints.up("md"));
  const [open, setOpen] = React.useState(false);
  const [anchorMessageEl, setAnchorMessageEl] = React.useState(null);
  const [anchorNotificationEl, setAnchorNotificationEl] = React.useState(null);
  const [drawerState, setDrawerState] = React.useState(false);

  const [drawerNotificationState, setNotificationDrawerState] =
    React.useState(false);

;
  const handleNotificationClick = React.useCallback(() => {
    setOpenNotificationPanel(true);
    setMobileMenu(false)
  }, []);

  const handleMessageClick = React.useCallback(() => {
    setOpenMessagePanel(true)
    setMobileMenu(false)
  }, []);

 

  const {
    auth,
    dashboardInfo: { entityProfileSelect },
  } = useSelector((state) => state);
  const { status } = auth.user || {};
  const { entity, userType, userId } = auth.profile || {};
  const [messageUserCount, setMessageUserCount] = React.useState(0);
  const [notificationUserCount, setNotificationUserCount] = React.useState(0);
  const [messsageUnreadCount, setMessageUnReadCount] = React.useState(0);
  const SearchBox = styled(TextField)(({ theme }) => ({
    fieldset: {
      borderRadius: "50px",
    },
    [theme.breakpoints.up("md")]: {
      display: "flex",
    },
  }));

  const handleProfile = React.useCallback(() => {
    setOpen(true);
  }, []);

  const selectedProfile = React.useMemo(
    () => profileLogged.find((item) => item.value === entityProfileSelect),
    [entityProfileSelect]
  );

  React.useEffect(() => {
    const getMessageUserCount = () => {
      const q = query(
        collectionGroup(db, "messages"),
        where("isRead", "==", false),
        where("recevierId", "==", userId)
      );
      const unsub = onSnapshot(q, (querySnapshot) => {
        setMessageUserCount(querySnapshot.size);
      });
      return () => {
        unsub();
      };
    };
    const getNotificationCount = () => {
      const q = query(
        firebaseCollection(db, "notifications"),
        where("isRead", "==", false),
        where("donorUserId", "==", userId)
      );
      const unsub = onSnapshot(q, (querySnapshot) => {
        setNotificationUserCount(querySnapshot.size);
      });
      return () => {
        unsub();
      };
    };
    getNotificationCount();
    getMessageUserCount();
  }, []);

  const navigate = useNavigate();

  const dispatch = useDispatch();
  const handleLogout = (e) => {
    e.preventDefault();
    dispatch(logout());
    dispatch(clearCart());
    dispatch(resetDashBoard());
    // localStorage.removeItem("userData");
    // localStorage.removeItem("entityProfile");
       removeFromIndexedDB("profiles", "entityProfile");
        removeFromIndexedDB("userData", "userData");
        removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
    navigate("/");
  };
  return (
    <Box sx={{display: "flex" , flexDirection:"column"}}>
      {entity.isGroupEntity && entity.isParentEntity ? null : (
       <Button onClick={handleMessageClick} sx={{display: "flex", flexDirection: "row" , flexWrap: "nowrap" , alignItems: "center" , marginBottom: "15px"}}>
        
            <Box sx={headerButtonStyles}>
                <Badge badgeContent={messageUserCount} sx={badgeColor} max={99}>
                <ChatOutlinedIcon
                    sx={{ color: "black", width: "18px", height: "18px" }}
                />
                </Badge>
            </Box>
          
        <Typography variant="body1" fontWeight={"bold"} sx={{marginLeft: "15px"}}>
            {t("messages")}
            </Typography>
       </Button>
         )}
        <Button onClick={handleNotificationClick} sx={{display: "flex", flexDirection: "row" , flexWrap: "nowrap" , alignItems: "center" , marginBottom: "15px"}}>
            <Box sx={headerButtonStyles} >
            <Badge badgeContent={notificationUserCount} sx={badgeColor} max={99}>
                <NotificationsNoneOutlinedIcon
                sx={{ color: "black", width: "18px", height: "18px" }}
                />
            </Badge>
            </Box>
            <Typography variant="body1" fontWeight={"bold"} sx={{marginLeft: "15px"}}>
            {t("notifications")}
            </Typography>
        </Button>
        <Button onClick={(e) => handleLogout(e)} sx={{display: "flex", flexDirection: "row" , flexWrap: "nowrap" , alignItems: "center" , justifyContent: "flex-start" }}>
            <Box sx={headerButtonStyles} >
            <Logout  sx={{ color: "black", width: "18px", height: "18px" }} />
            </Box>
            <Typography variant="body1" fontWeight={"bold"} sx={{marginLeft: "15px"}}>
            {'LogOut'}
            </Typography>
        </Button>
    </Box>
  );
};

export default MobilePanelOpenCard;
